import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import { Checkbox } from "@material-ui/core";
import PinInput from "react-pin-input";
import {
  createCardWallet,
} from "../../../../services/Store/Actions/walletAction";
import YBLTermsConditionsModal from "../../../Modals/YBLTermsConditionsModal";

function CreateCardWallet(props) {
  const { toggle, modal, setModal } = props;
  const [display1, setDisplay1] = useState(false);
  const [ search1, setSearch1] = useState("");
  const [ color1, setColor1] = useState(-1);

  
  const dispatch = useDispatch();
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please enter your name"),
    phone: Yup.string()
      .required("Phone number must contain 10 digits")
      .matches(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "Phone number must contain 10 digits"
      ),
  });
  const handleClose = () => {
    setModal(!modal);
  };

  const [openT, setOpenT] = useState(false);
  const toggleTermModal = () => {
    setOpenT(!openT);
  };
  const handleTermClose = () => {
    setOpenT(false);
  };
  const handleTermShow = () => {
    setOpenT(true);
  };

  return (
    <div>
      <YBLTermsConditionsModal
        handleClose={handleTermClose}
        open={openT}
        toggleModal={toggleTermModal}
      />
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{ marginTop: " 30px" }}
            //   className="PGCollectionBox"
          >
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Card Wallet KYC
            </div>

            <Formik
              // isValid='true'
              enableReinitialize
              validationSchema={validationSchema}
              initialValues={{
                phone:  "",
                name: "",
                panNo:  "",
                email:  "",
                gstNo:  "",
                sourceAccountNo:  "",
                sourceIfsc:  "",
                agree: false,
              }}
              onSubmit={(values, actions) => {
                 const data = {
                  name: values?.name,
                  phone: values?.phone,
                  pan: values?.panNo,
                  sourceAccount: values?.sourceAccountNo,
                  sourceIfsc: values?.sourceIfsc,
                  gst: values?.gstNo,
                  email: values?.email
                }
                  dispatch(
                      createCardWallet(
                        data,
                        (res) => {
                          console.log("eeeergrere", res);
                          if (res?.type == "success") {
                            //TODO
                          }
                        }
                      )
                    );
                }}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  style={{ marginTop: "40px", padding: "0 0px 0 55px" }}
                >
                  <FormGroup>
                    <div className="row">
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Name
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="name"
                            className={`inputBoxAddCust ${
                              touched.name && errors.name
                                ? "is-invalid"
                                : ""
                            }`}
                            name="name"
                            value={values.name}
                            onChange={handleChange("name")}
                            onBlur={handleBlur("name")}
                            touched={touched.name}
                            errors={errors.name}
                            placeholder="Name"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.name && touched.name ? (
                              <div>*{errors.name}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Phone Number
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="phone"
                            className={`inputBoxAddCust ${
                              touched.phone && errors.phone ? "is-invalid" : ""
                            }`}
                            name="phone"
                            value={values.phone}
                            onChange={handleChange("phone")}
                            onBlur={handleBlur("phone")}
                            touched={touched.phone}
                            errors={errors.phone}
                            placeholder="Phone Number"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.phone && touched.phone ? (
                              <div>*{errors.phone}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="panNo" className="heading3 semiBold">
                            Pan
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="panNo"
                            className={`inputBoxAddCust ${
                              touched.panNo && errors.panNo
                                ? "is-invalid"
                                : ""
                            }`}
                            name="panNo"
                            value={values.panNo}
                            onChange={handleChange("panNo")}
                            onBlur={handleBlur("panNo")}
                            touched={touched.panNo}
                            errors={errors.panNo}
                            placeholder="Pan"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.panNo && touched.panNo ? (
                              <div>*{errors.panNo}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="email" className="heading3 semiBold">
                            Email (Optional)
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="email"
                            className={`inputBoxAddCust ${
                              touched.email && errors.email ? "is-invalid" : ""
                            }`}
                            name="email"
                            value={values.email}
                            onChange={handleChange("email")}
                            onBlur={handleBlur("email")}
                            touched={touched.email}
                            errors={errors.email}
                            placeholder="E-mail"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.email && touched.email ? (
                              <div>*{errors.email}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <div className="row">
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="gstNo" className="heading3 semiBold">
                            GST No
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="gstNo"
                            className={`inputBoxAddCust ${
                              touched.gstNo && errors.gstNo
                                ? "is-invalid"
                                : ""
                            }`}
                            name="gstNo"
                            value={values.gstNo}
                            onChange={handleChange("gstNo")}
                            onBlur={handleBlur("gstNo")}
                            touched={touched.gstNo}
                            errors={errors.gstNo}
                            placeholder="GST No"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.gstNo && touched.gstNo ? (
                              <div>*{errors.gstNo}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="sourceAccountNo" className="heading3 semiBold">
                            Account Number
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="sourceAccountNo"
                            className={`inputBoxAddCust ${
                              touched.sourceAccountNo && errors.sourceAccountNo ? "is-invalid" : ""
                            }`}
                            name="sourceAccountNo"
                            value={values.sourceAccountNo}
                            onChange={handleChange("sourceAccountNo")}
                            onBlur={handleBlur("sourceAccountNo")}
                            touched={touched.sourceAccountNo}
                            errors={errors.sourceAccountNo}
                            placeholder="Account Number"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.sourceAccountNo && touched.sourceAccountNo ? (
                              <div>*{errors.sourceAccountNo}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="sourceIfsc" className="heading3 semiBold">
                            IFSC
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="sourceIfsc"
                            className={`inputBoxAddCust ${
                              touched.sourceIfsc && errors.sourceIfsc
                                ? "is-invalid"
                                : ""
                            }`}
                            name="sourceIfsc"
                            value={values.sourceIfsc}
                            onChange={handleChange("sourceIfsc")}
                            onBlur={handleBlur("sourceIfsc")}
                            touched={touched.sourceIfsc}
                            errors={errors.sourceIfsc}
                            placeholder="IFSC"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.sourceIfsc && touched.sourceIfsc ? (
                              <div>*{errors.sourceIfsc}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-3 row">
                        <div className="col-12">
                          <label for="email" className="heading3 semiBold">
                            Email (Optional)
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="email"
                            className={`inputBoxAddCust ${
                              touched.email && errors.email ? "is-invalid" : ""
                            }`}
                            name="email"
                            value={values.email}
                            onChange={handleChange("email")}
                            onBlur={handleBlur("email")}
                            touched={touched.email}
                            errors={errors.email}
                            placeholder="E-mail"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.email && touched.email ? (
                              <div>*{errors.email}</div>
                            ) : null}
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </FormGroup>
                  <FormGroup
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "space-between",
                    //   marginTop: "30px",
                    // }}
                    style={{
                      padding: "0px 0 0 0",
                    }}
                  >
                    <div style={{}} className="row">
                      {/* <div
                        className="offset-3 col-1"
                        style={{ padding: "0 0 0 40px" }}
                      >
                        <Checkbox
                          value={values?.agree}
                          sx={{
                            color: "#6c6c6c",
                            "&.Mui-checked": {
                              color: "#2E7C7B",
                            },
                          }}
                          onChange={(e) => {
                            console.log("kjdjjdjd", e?.target?.checked);
                            setFieldValue("agree", e?.target?.checked, true);
                          }}
                        />
                      </div>
                      <div
                        className="col-6 FontNS16"
                        style={{
                          paddingTop: "9px",
                          textDecoration: "underline",
                        }}
                        onClick={()=>{handleTermShow()}}
                      >
                        I Accept, terms & Conditions
                      </div> */}
                      {console.log("jdjiekek", values)}
                      <div
                        className="col-12"
                        style={{
                          textAlign: "center",
                          padding: "0 50px 0 0px",
                        }}
                      >
                        <Button
                          type="submit"
                          style={{ width: "160px", borderRadius: "5px" }}
                          className="generateOtp textAddCust Medium btn"
                          //   onClick={sendOtp}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    style={{
                      padding: "25px 0 0 0",
                      textAlign: "center",
                    }}
                  >
                    
                  </FormGroup>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CreateCardWallet;
